import { connect } from 'react-redux';

import { finishOverwriteTimeslot, startOverwriteTimeslot, toggleBookAppointmentModal } from "../../../redux/timeslots/actions";
import { getUserByPnr } from "../../../redux/users/actions";
import {
  bookAppointment,
  cancelAppointmentBooking,
  overwriteTimeslot,
  toggleOverwriteModal
} from "../../../redux/reservations/actions";
import BookAppointment from "./BookAppointment";

const mapStateToProps = (state) => ({
  selectedTimeslot: state.timeslotsReducer.selectedTimeslot,
  bookAppointmentModalIsOpen: state.timeslotsReducer.bookAppointmentModalIsOpen,
  userByPnr: state.usersReducer.userByPnr,
  bookedReservations: state.timeslotsReducer.bookedReservations,
  bloodBankId: state.authReducer.currentBloodbank,
  bloodBankName: state.authReducer.currentBloodbankName,
  isOverwriting:state.reservationReducer.isTimeslotOverwriting,
  overwritingError: state.reservationReducer.overwritingError,
  isOverwriteModalOpened: state.reservationReducer.isOverwriteModalOpened,
  appointmentTypes: state.appointmentTypesReducer.appointmentTypes || [],
  recurrenceRule: state.timeslotsReducer.recurrenceRule,
  currentAppointment: state.timeslotsReducer.currentAppointment,
  isDayPage: state.timeslotsReducer.isDayPage
});

const mapDispatchToProps = {
  toggleBookAppointmentModal,
  getUserByPnr,
  bookAppointment,
  cancelAppointmentBooking,
  overwriteTimeslot,
  toggleOverwriteModal,
  startOverwriteTimeslot,
  finishOverwriteTimeslot
};

export default connect(mapStateToProps, mapDispatchToProps)(BookAppointment);
